/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/quotes */
import type { SVGProps } from "react";

const CheckCircle: React.FC<Partial<SVGProps<SVGSVGElement>>> = (props: Partial<SVGProps<SVGSVGElement>>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99967 0.333313C3.33301 0.333313 0.333008 3.33331 0.333008 6.99998C0.333008 10.6666 3.33301 13.6666 6.99967 13.6666C10.6663 13.6666 13.6663 10.6666 13.6663 6.99998C13.6663 3.33331 10.6663 0.333313 6.99967 0.333313ZM6.99967 12.3333C4.05967 12.3333 1.66634 9.93998 1.66634 6.99998C1.66634 4.05998 4.05967 1.66665 6.99967 1.66665C9.93967 1.66665 12.333 4.05998 12.333 6.99998C12.333 9.93998 9.93967 12.3333 6.99967 12.3333ZM10.0597 4.05331L5.66634 8.44665L3.93967 6.72665L2.99967 7.66665L5.66634 10.3333L10.9997 4.99998L10.0597 4.05331Z" fill={props.color ?? "#602F96"} />
  </svg>
);

export default CheckCircle;
